import React from "react";
import "./footter-styles.css";
import texts from "../../texts.json";

const Footer = () => {
  return <div className="footer">{texts.footer}</div>;
};

export { Footer };
